import { useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const API = `${window.location.origin}/api`;

const INITIAL_STATE = {
  invoice_number: '', amount: '', remarks: '',
  customer_name: '', customer_phone: '',
  customer_email: '', due_date: '',
};

export const PendingEntryForm = ({ selectedDate, onEntryAdded }) => {
  const [form, setForm] = useState(INITIAL_STATE);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.invoice_number || !form.amount || !form.customer_name) {
      toast.error('Please fill required fields');
      return;
    }
    try {
      setLoading(true);
      await axios.post(`${API}/pending-payments`, {
        date: selectedDate,
        invoice_number: form.invoice_number,
        amount: parseFloat(form.amount),
        remarks: form.remarks,
        customer_name: form.customer_name,
        customer_phone: form.customer_phone,
        customer_email: form.customer_email,
        due_date: form.due_date,
      });
      toast.success('Pending payment added!');
      setForm(INITIAL_STATE);
      onEntryAdded();
    } catch (err) {
      toast.error('Failed to add pending payment');
    } finally {
      setLoading(false);
    }
  };

  const update = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  return (
    <form onSubmit={handleSubmit} className="space-y-3" data-testid="pending-entry-form">
      <div>
        <Label className="text-sm font-semibold">Invoice Number *</Label>
        <Input value={form.invoice_number} onChange={(e) => update('invoice_number', e.target.value)} placeholder="INV-001" required />
      </div>
      <div>
        <Label className="text-sm font-semibold">Customer Name *</Label>
        <Input value={form.customer_name} onChange={(e) => update('customer_name', e.target.value)} placeholder="Customer" required />
      </div>
      <div>
        <Label className="text-sm font-semibold">Amount (₹) *</Label>
        <Input type="number" step="0.01" value={form.amount} onChange={(e) => update('amount', e.target.value)} className="currency" placeholder="0.00" required />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div>
          <Label className="text-sm font-semibold text-xs">Phone</Label>
          <Input value={form.customer_phone} onChange={(e) => update('customer_phone', e.target.value)} placeholder="Phone" />
        </div>
        <div>
          <Label className="text-sm font-semibold text-xs">Email</Label>
          <Input type="email" value={form.customer_email} onChange={(e) => update('customer_email', e.target.value)} placeholder="Email" />
        </div>
      </div>
      <div>
        <Label className="text-sm font-semibold">Due Date (DD/MM/YYYY)</Label>
        <Input value={form.due_date} onChange={(e) => update('due_date', e.target.value)} placeholder="25/03/2026" />
      </div>
      <div>
        <Label className="text-sm font-semibold">Remarks</Label>
        <Input value={form.remarks} onChange={(e) => update('remarks', e.target.value)} placeholder="Notes" />
      </div>
      <Button type="submit" disabled={loading} className="w-full premium-button bg-gradient-to-r from-orange-500 to-yellow-600 text-white hover:from-orange-600 hover:to-yellow-700" data-testid="submit-pending-btn">
        {loading ? 'Adding...' : 'Add Pending Payment'}
      </Button>
    </form>
  );
};
